import { render, staticRenderFns } from "./processAffairAdd.vue?vue&type=template&id=2b86e3a0&"
import script from "./processAffairAdd.vue?vue&type=script&lang=js&"
export * from "./processAffairAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports